import React, { useContext } from "react";
import DarkModeToggle from "../DarkModeToggle";
import { FaBars, FaSignOutAlt } from "react-icons/fa";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

// Terima prop pageTitle
const Topbar = ({ toggleSidebar, user, pageTitle }) => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="flex items-center justify-between bg-gray-50 dark:bg-gray-800 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center gap-2">
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-100"
        >
          <FaBars />
        </button>
        <span className="text-lg font-semibold text-gray-800 dark:text-gray-100">
          {pageTitle} {/* Ganti dengan prop pageTitle */}
        </span>
      </div>

      <div className="flex items-center gap-4">
        <DarkModeToggle />
        <div className="text-gray-800 dark:text-gray-100 font-medium">
          {user?.namaLengkap || user?.username}
        </div>
        <button
          onClick={handleLogout}
          className="p-2 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-100"
          title="Logout"
        >
          <FaSignOutAlt />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
